import { X } from 'lucide-react'
import { cn } from '@/lib/cn'

export function Chip({
  label,
  onRemove,
  className,
}: {
  label: string
  /** Supplying this makes the chip removable and adds the ✕ affordance. */
  onRemove?: () => void
  className?: string
}) {
  return (
    <span
      className={cn(
        'inline-flex max-w-full items-center gap-1 rounded-[4px] bg-surface-sunk',
        'px-1.5 py-0.5 text-[11px] leading-4 text-ink-muted',
        className,
      )}
    >
      <span className="truncate">{label}</span>
      {onRemove && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation()
            onRemove()
          }}
          aria-label={`Remove tag ${label}`}
          className="-mr-0.5 shrink-0 rounded-[2px] text-ink-faint hover:text-brand-red-700"
        >
          <X size={11} aria-hidden />
        </button>
      )}
    </span>
  )
}
